/**
 * Auto-capitalize: converts text to Title Case (first letter of each word capitalized).
 * Use as onBlur handler on text inputs for name fields.
 */
export const toTitleCase = (str) => {
  if (!str) return str;
  return str.trim().replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * onBlur handler factory for auto-capitalizing input fields.
 * Usage: <Input onBlur={autoCapitalize(setter)} />
 * or: <Input onBlur={autoCapitalize((val) => setData({...data, field: val}))} />
 */
export const autoCapitalize = (setter) => (e) => {
  const val = e.target.value;
  if (val && val !== toTitleCase(val)) {
    setter(toTitleCase(val));
  }
};
